import React from "react";
import { Table, Button, Alert } from "reactstrap";
import { Rating } from "./Rating";
import { setDoc, doc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase-config";
import { lecturersState } from "../atoms";
import { useRecoilState } from "recoil";
import SearchBox from "./SearchBox";
import { useMemo } from "react";
import { SpinnerLoader } from "./Spinner";
import { Link } from "react-router-dom";
export const LecturersTable = (props) => {
  const {
    readOnly,
    explanationValues,
    setExplanationValues,
    communicationValues,
    setCommunicationValues,
    fairnessValues,
    setFairnessValues,
    initialSearch,
  } = props;

  const [lecturersList, setLecturersList] = useRecoilState(lecturersState);
  const [search, setSearch] = React.useState(
    initialSearch ? [initialSearch] : []
  );
  const [submissionsMade, setSubmissionsMade] = React.useState(
    JSON.parse(localStorage.getItem("submissionsMade")) || []
  );

  const [isSubmitting, setIsSubmitting] = React.useState();

  const searchResults = useMemo(() => {
    if (!search) return lecturersList;
    if (!lecturersList) return [];

    if (search.length === 0) {
      return lecturersList;
    }

    let filteredList = [];

    search.forEach((searchTerm, index) => {
      lecturersList.forEach((lecturer) => {
        if (lecturer.name.toLowerCase().includes(searchTerm.toLowerCase())) {
          filteredList.push(lecturer);
        }
      });
      index !== search.length - 1 && filteredList.push("separator");
    });

    return filteredList;

    // return lecturersList.filter((lecturer) => {
    //   return lecturer.name.toLowerCase().includes(search.toLowerCase());
    // });
  }, [search, lecturersList]);

  const calculateNewAverages = (
    newExplanationRating,
    newCommunicationRating,
    newFairnessRating,
    lecturerId
  ) => {
    const existingLecturerObject = lecturersList[lecturerId];
    let oldNumberOfRatings = existingLecturerObject.numberOfRatings
      ? existingLecturerObject.numberOfRatings
      : 0;
    let numberOfRatings = existingLecturerObject.numberOfRatings
      ? existingLecturerObject.numberOfRatings + 1
      : 1;

    const newExplanationAverage =
      (existingLecturerObject.averageRating1 * oldNumberOfRatings +
        newExplanationRating) /
      numberOfRatings;
    const newCommunicationAverage =
      (existingLecturerObject.averageRating2 * oldNumberOfRatings +
        newCommunicationRating) /
      numberOfRatings;
    const newFairnessAverage =
      (existingLecturerObject.averageRating3 * oldNumberOfRatings +
        newFairnessRating) /
      numberOfRatings;
    return {
      averageRating1: newExplanationAverage,
      averageRating2: newCommunicationAverage,
      averageRating3: newFairnessAverage,
      numberOfRatings,
    };
  };

  const handleSubmit = async (e) => {
    if (readOnly) return;
    e.preventDefault();

    console.log("submitting ");

    const id = +e.target.id.value;
    //console.log("suspicious id", id);

    setIsSubmitting({ id: id, value: true });

    const newExplanationRating = +explanationValues[id];
    const newCommunicationRating = +communicationValues[id];
    const newFairnessRating = +fairnessValues[id];

    //  TODO: add vote to db table votes
    // The firestore function will then calculate the average
    // and update the lecturer object in the lecturers collection

    const newData = {
      newRating1: newExplanationRating,
      newRating2: newCommunicationRating,
      newRating3: newFairnessRating,
      lecturerId: id,
      lecturerName: lecturersList[id].name,
    };

    const updatedLecturerData = calculateNewAverages(
      newExplanationRating,
      newCommunicationRating,
      newFairnessRating,
      id
    );

    try {
      const lecturersCollectionRef = collection(db, "evaluations");

      // get current date and time to match serverTimeStamp format
      const currentDateTime = serverTimestamp();
      console.log(currentDateTime);
      const newEvaluation = await setDoc(
        doc(
          db,
          "evaluations",
          `
        ${Date.now()}
        -
        ${lecturersList[id].name}`
        ),
        {
          ...newData,
          createdAt: serverTimestamp(),
        }
      );
      // console.log("newEvaluation", newEvaluation);

      setLecturersList(
        lecturersList.map((lecturer) => {
          if (lecturer.id === id) {
            return {
              ...lecturer,
              ...updatedLecturerData,
            };
          }
          return lecturer;
        })
      );

      const newSubmissionsMade = [...submissionsMade];
      newSubmissionsMade[id] = {
        averageRating1: newExplanationRating,
        averageRating2: newCommunicationRating,
        averageRating3: newFairnessRating,
      };

      setSubmissionsMade(newSubmissionsMade);
      localStorage.setItem(
        "submissionsMade",
        JSON.stringify([...newSubmissionsMade])
      );
    } catch (error) {
      console.log(error);
    }
  };

  //console.log("explanation values", explanationValues);

  const handleExplanationValueChange = React.useCallback(
    (value, index) => {
      if (readOnly) {
        return;
      }

      setExplanationValues((prevExplanaitonValues) => {
        const newValues = [...prevExplanaitonValues];
        newValues[index] = value;
        return newValues;
      });
    },
    [setExplanationValues, readOnly]
  );

  const handleCommunicationValueChange = React.useCallback(
    (value, index) => {
      if (readOnly) {
        return;
      }
      //console.log("value", value);
      //console.log("index", index);
      setCommunicationValues((prevCommunicationValues) => {
        const newValues = [...prevCommunicationValues];
        newValues[index] = value;
        return newValues;
      });
    },
    [setCommunicationValues, readOnly]
  );

  const handleFairnessValueChange = React.useCallback(
    (value, index) => {
      if (readOnly) {
        return;
      }
      //console.log("value", value);
      //console.log("index", index);
      setFairnessValues((prevFairnessValues) => {
        const newValues = [...prevFairnessValues];
        newValues[index] = value;
        return newValues;
      });
    },
    [setFairnessValues, readOnly]
  );

  const isSubmittedFn = (id) => {
    return submissionsMade[id] !== undefined && submissionsMade[id] !== null;
  };

  const isSubmittingFn = (id) => {
    return isSubmitting && isSubmitting.id === id && isSubmitting.value;
  };
  return (
    <>
      <div className="alert alert-info">
        Search for a lecturer, or use comma as a separator to compare lecturers
        (eg.: name1,name2)
      </div>
      <SearchBox setSearch={setSearch} searchDelay={10} />
      <Table borderless dark hover responsive striped size="sm">
        <thead>
          <tr>
            <th></th>
            <th scope="row">Lecturer's Name</th>
            <th className="text-center">Explanation</th>
            <th className="text-center">Communication</th>
            <th className="text-center">Course Outcome</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          {lecturersList && lecturersList.length ? (
            searchResults?.map((lecturer, index) => {
              //console.log (lecturer.name, lecturer.id);
              if (lecturer === "separator")
                return (
                  <tr key={index}>
                    <td colSpan="6" className="text-center">
                      {/* hr with word in the middle */}
                      <hr className="my-2" />
                      <span className="text-center">
                        <h5>and...</h5>
                      </span>
                      <hr className="my-2" />
                    </td>
                  </tr>
                );

              return (
                <tr key={index}>
                  <td>
                    <form onSubmit={handleSubmit} id={`form-${lecturer.id}`}>
                      <input
                        name="id"
                        value={lecturer.id || 0}
                        readOnly
                        hidden
                      ></input>{" "}
                    </form>
                  </td>
                  <td valign="middle">{lecturer.name}</td>

                  {readOnly ? (
                    <>
                      <td align="center" className="px-4">
                        <Rating
                          ratingType="explanation"
                          ratingValue={lecturer.averageRating1 || 0}
                          numberOfRatings={lecturer.numberOfRatings}
                          readOnly={readOnly}
                        ></Rating>
                      </td>
                      <td align="center" className="px-4">
                        <Rating
                          ratingType="communication"
                          ratingValue={lecturer.averageRating2 || 0}
                          numberOfRatings={lecturer.numberOfRatings}
                          readOnly={readOnly}
                        ></Rating>
                      </td>
                      <td align="center" className="px-4">
                        <Rating
                          ratingType="fairness"
                          ratingValue={lecturer.averageRating3 || 0}
                          numberOfRatings={lecturer.numberOfRatings}
                          readOnly={readOnly}
                        ></Rating>
                      </td>
                      <td valign="middle" align="center">
                        <Link
                          to={{
                            pathname: "/evaluate-lecturer",
                            search: "?name=" + lecturer.name,
                          }}
                          className="btn btn-primary btn-sm"
                        >
                          Evaluate
                        </Link>
                      </td>
                    </>
                  ) : (
                    <>
                      <td align="center" valign="middle">
                        <Rating
                          ratingType="explanation"
                          ratingValue={
                            explanationValues[lecturer.id] ||
                            submissionsMade[lecturer.id]?.averageRating1 ||
                            0
                          }
                          readOnly={readOnly}
                          setRatingValue={handleExplanationValueChange}
                          lecturerIndex={lecturer.id}
                          disabled={isSubmittedFn(lecturer.id)}
                        />
                      </td>
                      <td align="center" valign="middle">
                        <Rating
                          ratingType="communication"
                          ratingValue={
                            communicationValues[lecturer.id] ||
                            submissionsMade[lecturer.id]?.averageRating2 ||
                            0
                          }
                          readOnly={readOnly}
                          setRatingValue={handleCommunicationValueChange}
                          lecturerIndex={lecturer.id}
                          disabled={isSubmittedFn(lecturer.id)}
                        />
                      </td>
                      <td align="center" valign="middle">
                        <Rating
                          ratingType="fairness"
                          ratingValue={
                            fairnessValues[lecturer.id] ||
                            submissionsMade[lecturer.id]?.averageRating3 ||
                            0
                          }
                          readOnly={readOnly}
                          setRatingValue={handleFairnessValueChange}
                          lecturerIndex={lecturer.id}
                          disabled={isSubmittedFn(lecturer.id)}
                        />
                      </td>
                      <td valign="middle" align="center">
                        <Button
                          type="submit"
                          // className="btn btn-sm"
                          form={`form-${lecturer.id}`}
                          disabled={
                            isSubmittingFn(lecturer.id) ||
                            isSubmittedFn(lecturer.id)
                          }
                          color={
                            isSubmittingFn(lecturer.id) ||
                            isSubmittedFn(lecturer.id)
                              ? "secondary"
                              : "success"
                          }
                        >
                          {isSubmittedFn(lecturer.id) ? (
                            <>Done ✔️</>
                          ) : isSubmittingFn(lecturer.id) ? (
                            <SpinnerLoader type={"grow"} size="sm" count={3} />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </td>
                    </>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" align="center">
                <SpinnerLoader />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
